module.exports = __webpack_public_path__ + "static/sponsorship_img-08-a@2x-f9c2aa50d3771198826ac96d0925c9bf.jpg";